import React from 'react';
import styles from '@stylesheet';
import { Text, View } from 'react-native';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import DefaultScreen from '@components/Global/DefaultScreenView';

const RemindersScreen = () => {
  const theme = themeSelector();

  return (
    <DefaultScreen backButton>
      <View style={[styles.container, { backgroundColor: theme ? '#ffffff' : '#1a1a1a', flex: 1, padding: 20 }]}>
        <Text
          adjustsFontSizeToFit
          style={[
            styles.title,
            { color: theme ? '#1f2937' : '#f9fafb', marginBottom: 20 }
          ]}
        >
          Reminders
        </Text>
        <View
          style={[
            styles.separator,
            {
              backgroundColor: theme ? '#e5e7eb' : 'rgba(255,255,255,0.1)',
              marginBottom: 20
            }
          ]}
        />
        {/* TODO: Implement reminders functionality */}
        <Text style={{ color: theme ? '#6b7280' : '#9ca3af', textAlign: 'center', marginTop: 20 }}>
          Reminders feature coming soon...
        </Text>
      </View>
    </DefaultScreen>
  );
};

export default RemindersScreen;